import { render, staticRenderFns } from "./support_protocol_detail.vue?vue&type=template&id=18b3acf8"
import script from "./support_protocol_detail.vue?vue&type=script&lang=js"
export * from "./support_protocol_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports